document.addEventListener('DOMContentLoaded', function() {
    initGLightbox();
});

function initGLightbox() {

    const lightbox = GLightbox({
        touchNavigation: true,
        loop: true,
        keyboardNavigation: true,
        autoplayVideos: true
    });


    localizeGLightbox(lightbox);
    keepFocusOrder(lightbox);
}
function keepFocusOrder(lightbox) {
    let lastFocusedElement = null;
    document.querySelectorAll('.glightbox').forEach((item) => {
        item.addEventListener('click', function() {
            lastFocusedElement = this;
        });
    });
    lightbox.on('close', (data) => {
        lastFocusedElement.focus();
    });
}

function localizeGLightbox(lightbox) {
    lightbox.on('open', () =>
    {
        if(lightbox.modal){
            lightbox.modal.setAttribute('aria-label', 'Bildansicht');
            lightbox.modal.querySelector('.gclose').setAttribute('aria-label', 'Schließen');
            lightbox.modal.querySelector('.gnext').setAttribute('aria-label', 'Nächste Folie');
            lightbox.modal.querySelector('.gprev').setAttribute('aria-label', 'Vorherige Folie');
            lightbox.modal.querySelector('.gclose').querySelector('svg').setAttribute('aria-hidden', 'true');
            lightbox.modal.querySelector('.gnext').querySelector('svg').setAttribute('aria-hidden', 'true');
            lightbox.modal.querySelector('.gprev').querySelector('svg').setAttribute('aria-hidden', 'true');
        }
    });
}
